<div class="wrapper">
    <a class="logo" [routerLink]="ROUTE_CONSTANTS.HOME">
        <img class="logo-img" src="assets/images/header/logo.png" alt="{{ 'header.logoAlt' | translate }}" />
    </a>

    @if (user$ | async; as user) {
        <nav class="main-nav">
            <a
                class="nav-button"
                [routerLink]="ROUTE_CONSTANTS.HOME"
                routerLinkActive="active"
                ariaCurrentWhenActive="page"
                [routerLinkActiveOptions]="{ exact: true }">
                {{ 'header.home' | translate }}
            </a>
            <a
                class="nav-button"
                [routerLink]="[ROUTE_CONSTANTS.CALENDAR]"
                routerLinkActive="active"
                ariaCurrentWhenActive="page">
                {{ 'header.calendar' | translate }}
            </a>
            <a
                class="nav-button"
                [routerLink]="[ROUTE_CONSTANTS.SQUAD]"
                routerLinkActive="active"
                ariaCurrentWhenActive="page">
                {{ 'header.squad' | translate }}
            </a>
            <a
                class="nav-button"
                [routerLink]="[ROUTE_CONSTANTS.SESSIONS]"
                routerLinkActive="active"
                ariaCurrentWhenActive="page">
                {{ 'header.history' | translate }}
            </a>
            <a
                class="nav-button"
                [routerLink]="[ROUTE_CONSTANTS.USER.ROOT]"
                routerLinkActive="active"
                ariaCurrentWhenActive="page">
                {{ 'header.profile' | translate }}
            </a>
        </nav>

        <!-- Mobile only (< 768px): nav and logout collapse into this dropdown. -->
        <div class="mobile-menu">
            <button
                type="button"
                class="menu-toggle"
                aria-controls="mobile-menu-panel"
                [attr.aria-expanded]="isMenuOpen"
                (click)="toggleMenu()">
                {{ currentPageLabel | translate }}
                <i-feather name="chevron-down" class="menu-chevron" [class.open]="isMenuOpen"></i-feather>
            </button>

            @if (isMenuOpen) {
                <nav id="mobile-menu-panel" class="menu-panel">
                    <a
                        class="menu-link"
                        [routerLink]="ROUTE_CONSTANTS.HOME"
                        routerLinkActive="active"
                        ariaCurrentWhenActive="page"
                        [routerLinkActiveOptions]="{ exact: true }"
                        (click)="closeMenu()">
                        {{ 'header.home' | translate }}
                    </a>
                    <a
                        class="menu-link"
                        [routerLink]="[ROUTE_CONSTANTS.CALENDAR]"
                        routerLinkActive="active"
                        ariaCurrentWhenActive="page"
                        (click)="closeMenu()">
                        {{ 'header.calendar' | translate }}
                    </a>
                    <a
                        class="menu-link"
                        [routerLink]="[ROUTE_CONSTANTS.SQUAD]"
                        routerLinkActive="active"
                        ariaCurrentWhenActive="page"
                        (click)="closeMenu()">
                        {{ 'header.squad' | translate }}
                    </a>
                    <a
                        class="menu-link"
                        [routerLink]="[ROUTE_CONSTANTS.SESSIONS]"
                        routerLinkActive="active"
                        ariaCurrentWhenActive="page"
                        (click)="closeMenu()">
                        {{ 'header.history' | translate }}
                    </a>
                    <a
                        class="menu-link"
                        [routerLink]="[ROUTE_CONSTANTS.USER.ROOT]"
                        routerLinkActive="active"
                        ariaCurrentWhenActive="page"
                        (click)="closeMenu()">
                        {{ 'header.profile' | translate }}
                    </a>
                    <a
                        class="menu-link logout"
                        [routerLink]="[ROUTE_CONSTANTS.AUTH.ROOT, ROUTE_CONSTANTS.AUTH.LOGOUT]"
                        (click)="closeMenu()">
                        {{ 'header.logout' | translate }}
                        <i-feather name="log-out" class="feather-icon"></i-feather>
                    </a>
                </nav>
            }
        </div>

        <div class="header-actions">
            <a [routerLink]="[ROUTE_CONSTANTS.AUTH.ROOT, ROUTE_CONSTANTS.AUTH.LOGOUT]" class="action-button thin">
                {{ 'header.logout' | translate }}
                <i-feather name="log-out" class="feather-icon"></i-feather>
            </a>
        </div>
    } @else {
        <div class="header-actions logged-out">
            <a [routerLink]="[ROUTE_CONSTANTS.AUTH.ROOT, ROUTE_CONSTANTS.AUTH.REGISTER]" class="action-button">
                {{ 'header.getStarted' | translate }}
            </a>
            <a [routerLink]="[ROUTE_CONSTANTS.AUTH.ROOT, ROUTE_CONSTANTS.AUTH.LOGIN]" class="action-button thin">
                {{ 'header.login' | translate }}
                <i-feather name="arrow-right" class="feather-icon"></i-feather>
            </a>
        </div>
    }
</div>
